import { createTheme } from '@one-thd/sui-atomic-components';

const WinterHoliday2026PrimarySix = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

WinterHoliday2026PrimarySix.palette['--sui-palette-background-primary'] = '152 5 11';

export { WinterHoliday2026PrimarySix };